import axios from 'axios'
import statusCodes from '../utils/http'
import {getTokens} from '../stores/auth'
import {toast} from 'react-toastify'
import tokens from '../utils/tokens'

const instances = [
    axios.create({baseURL: process.env.REACT_APP_AUTH_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_CUSTOMER_QUERY_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_CUSTOMER_CMD_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_RESOURCE_QUERY_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_RESOURCE_QUERY_US_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_RESOURCE_QUERY_AU_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_RESOURCE_QUERY_AS_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_RESOURCE_CMD_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_STATISTIC_QUERY_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_STATISTIC_QUERY_US_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_STATISTIC_QUERY_AU_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_STATISTIC_QUERY_AS_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_PAYMENT_QUERY_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_PAYMENT_CMD_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_EXTERNAL_STATUSPAGES_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_EXTERNAL_ZAPIER_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_ADMINIX_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_APPSUMO_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_STATUSPAGE_CMD_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_STATUSPAGE_QUERY_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_INCIDENT_CMD_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_INCIDENT_QUERY_API_URL}),
    axios.create({baseURL: process.env.REACT_APP_FILE_MANAGER_API_URL})
]

let failedQueue = []
let isRefreshing = false

export const applyInterceptors = (store) => {
    const processQueue = (error, token = null) => {
        failedQueue.forEach(({resolve, reject, config}) => {
            if (token) {
                config.headers.Authorization = `Bearer ${token}`
                const instance = instances.find(inst => config.baseURL === inst.defaults.baseURL)

                if (instance) {
                    resolve(instance(config))
                    return
                }
            }
            reject(error)
        })
        failedQueue = []
    }

    instances.forEach(instance => {
        instance.interceptors.response.use(
            response => response,
            async error => {
                if (error.config.skipInterceptor) {
                    return
                }

                const status = error.response?.status
                const originalRequest = error.config

                if (status === statusCodes.UnAuthorizedStatusCode) {
                    if (isRefreshing) {
                        return new Promise((resolve, reject) => {
                            failedQueue.push({resolve, reject, config: originalRequest})
                        })
                    }

                    isRefreshing = true
                    try {
                        await store.dispatch(getTokens())
                        const newToken = localStorage.getItem(tokens.token.key)
                        originalRequest.headers.Authorization = `Bearer ${newToken}`
                        processQueue(null, newToken)
                        return instance(originalRequest)
                    } catch (err) {
                        processQueue(err)
                        return Promise.reject(err)
                    } finally {
                        isRefreshing = false
                    }
                }

                if (status >= statusCodes.InternalErrorCode) {
                    toast.error('Internal server error')
                }
                if (status >= statusCodes.ValidationErrors && status < statusCodes.InternalErrorCode && !statusCodes.SpecialErrors.includes(status)) {
                    toast.error('Request is invalid')
                }

                return Promise.reject(error)
            }
        )

        instance.interceptors.request.use(config => {
            const tokenType = config?.token_type || tokens.token.key
            const token = localStorage.getItem(tokenType)
            if (token) {
                config.headers.Authorization = `Bearer ${token}`
            }
            return config
        })
    })
}

export const [
    authService,
    customerQueryService,
    customerCmdService,
    resourceQueryService,
    resourceQueryServiceUS,
    resourceQueryServiceAU,
    resourceQueryServiceAS,
    resourceCmdService,
    statisticQueryService,
    statisticQueryServiceUS,
    statisticQueryServiceAU,
    statisticQueryServiceAS,
    paymentQueryService,
    paymentCmdService,
    integrationCmdService,
    zapierService,
    adminixService,
    appsumoService,
    statuspageCmdService,
    statuspageQueryService,
    incidentCmdService,
    incidentQueryService,
    fileManagerService
] = instances
